module.exports = __webpack_public_path__ + "static/key-opus-a71b2eadc3d4f7d077fa2d58f568e8f3.webp";